import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=2de7e477&scoped=true"
import script from "./waterfall.vue?vue&type=script&lang=js"
export * from "./waterfall.vue?vue&type=script&lang=js"
import style0 from "./waterfall.vue?vue&type=style&index=0&id=2de7e477&prod&lang=less"
import style1 from "./waterfall.vue?vue&type=style&index=1&id=2de7e477&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de7e477",
  null
  
)

export default component.exports